import Link from 'next/link'
import { Avatar } from '@nextui-org/avatar'

import { timeDescription } from '@/utils/timeDescription'
import { PostCommentPayload } from '@/redux/reducers/feed/feed.type'
import { ItemFeed } from '@/components/shared/ContentFeed/CardSS/ItemFeed'

import styles from './styles.module.css'

type CommentItemProps = {
  data: PostCommentPayload
  index?: number
}
const CommentItem: React.FC<CommentItemProps> = (props) => {
  const { data, index } = props
  return (
    <div className={`${styles.comment__post__container} ${index !== 0 && styles.comment__post__container__border}`}>
      <div className={styles.account__wrapper}>
        <div className={styles.account__wrapper__info}>
          <Link
            href={data.creator?.commentAs === 'SPACE' ? `/spaces/${data.creator.id}` : `/profile/${data.creator.id}`}
          >
            <Avatar
              className="h-[32px] w-[32px]"
              src={
                data?.creator?.avatarImage || 'https://i.pinimg.com/564x/8a/9d/6e/8a9d6e85a93b8b3a8002896da71882a3.jpg'
              }
            />
          </Link>
          <div className={`${styles.account__wrapper__info__name}`}>
            <div className="flex justify-between">
              <div className="flex items-center gap-1">
                <ItemFeed.FeedName
                  info={{
                    creator: data?.creator.id,
                    nickname: data?.creator?.nickname,
                    isKOL: data.creator?.role?.value === 'kol',
                    postAs: data.creator?.commentAs || 'USER',
                  }}
                />

                <div className="flex items-center gap-1">
                  <div className="h-1 w-1 rounded-full bg-ss-grayscale-500" />
                  <p className="text-[14px] font-[600] text-[#808191]">
                    {props.data?.dateCreate && timeDescription(props.data?.dateCreate)}
                  </p>
                </div>
              </div>
              {/* <Dropdown className="border border-white/20 bg-black">
                <DropdownTrigger>
                  <div className="flex h-[22px] w-[22px] cursor-pointer items-center justify-center">
                    <Image alt="" src={ICONS.threeDotHorizontal} width={22} height={22} />
                  </div>
                </DropdownTrigger>
                <DropdownMenu variant="faded" aria-label="Dropdown menu with icons">
                  <DropdownItem
                    className="text-white hover:border-white/10 data-[hover=true]:bg-ss-dark data-[hover=true]:text-white"
                    key="report"
                    startContent={<Image src={ICONS.icFlag} alt="" width={16} height={16} />}
                  >
                    Report comment
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown> */}
            </div>

            <div className={styles.post__description__desk}>
              <ItemFeed.FeedContent content={data.content} postId={data.postId} />
            </div>
            {/* nếu có image thì không render metadata */}
            <ItemFeed.FeedImages images={data.imageUrl ? [data.imageUrl] : []} />
            <ItemFeed.FeedMetadata content={data.content} />
            <div className="flex items-center gap-2">
              {/* <div className="flex cursor-pointer items-center gap-1 text-xs text-ss-grayscale-500">
                <Image src={ICONS.heat} alt="sightsea" />
                <span>0</span>
              </div> */}
              {/* <div className="flex cursor-pointer items-center gap-1 text-xs text-ss-grayscale-500">
                                <Image src={ICONS.comment} alt="sightsea" />
                                <span>0</span>
                            </div>
                            <div className="flex cursor-pointer items-center gap-1 text-xs text-ss-grayscale-500">
                                <Image src={ICONS.share} alt="sightsea" />
                                <span>0</span>
                            </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CommentItem
